import axios from '@/integrations/axios'
import { toQueryParams } from '@/lib/utils'
import type { CabasEstimate, CabasEstimateListQuery } from '@backend/schemas'

export interface CabasEstimateListItem {
  id: string
  calculationId: string
  registrationNumber: string
  lastUpdate: string
  workshop: string
  damageDate?: string
}

export interface CabasEstimateListResponse {
  items: CabasEstimateListItem[]
  total: number
  page: number
  pageSize: number
}

export type CabasEstimateDetail = CabasEstimate & { carId?: string }

export const fetchCabasEstimates = async (params: Partial<CabasEstimateListQuery>) => {
  const response = await axios.get<CabasEstimateListResponse>(`/v1/estimates/cabas`, {
    params: toQueryParams(params),
  })
  return response.data
}

export const fetchCabasEstimateById = async (id: string) => {
  const response = await axios.get<CabasEstimateDetail>(`/v1/estimates/cabas/${id}`)
  return response.data
}
